import React from "react";
import classNames from "classnames";
import BaseReportTable, { formatSeconds } from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import moment from "moment";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function StaffAccountShiftsTable(props: IProps) {

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";
    if (newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        case "datetime":
          newValue = moment(value, "YYYY-MM-DD HH:mm:ss")?.format("LLL");
          break;
        case "seconds":
          newValue = formatSeconds(Number(value));
          break;
        default:
          break;
      }
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(_: string, cellValue: string, displayType: string) {
    return formatDisplay(displayType, cellValue);
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
      "report-table-cell-clickable": cell.column.id === "code",
    });
  }

  // Add footer data based on column
  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }

    switch (columnId) {
      case "user":
        return footerRow?.user as string;
      case "seconds_worked":
        return formatDisplay(
          "seconds",
          String(footerRow[columnId] ?? ""),
        );

      default:
        return footerRow[columnId] as string ?? null;
    }
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={() => { }}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={false}
    />
  );
}
